module.exports = __webpack_public_path__ + "img/dummy.0f22870f.jpg";